module.exports = __webpack_public_path__ + "static/media/slider.4f824617.jpg";